// src/features/links/labels.ts
// IR-1047 — display labels for the Join Links contract enums. Shared by the
// table (read render) and the Phase 2 edit cells (option labels) so the two
// never drift.
import type { OperationalStatus, Platform } from "./types";

export const PLATFORM_LABELS: Record<Platform, string> = {
  tg: "Telegram",
  wa: "WhatsApp",
  signal: "Signal",
};

export const OP_STATUS_LABELS: Record<OperationalStatus, string> = {
  new: "New",
  in_review: "In Review",
  waiting4approval: "Waiting for Approval",
  in_coverage: "In Coverage",
  rejected: "Rejected",
  broken: "Broken",
  obsolete: "Obsolete",
  failed: "Failed",
};
